import { EntityProcessInfo, UserRelations } from 'types';
import {
	DISABLED_STATUSES_EMPLOYEE,
	DISABLED_STATUSES_IPA,
	FLOW_TYPE,
	MIFID_STATUS,
	PROCESS_STATUS,
	RENEW_PREFIX
} from 'consts';

export function findSelected(data: UserRelations, ssn: string) {
	return [...data.children, ...data.companies, data.person].find(x => ssn === x.kennitala);
}

export function DecorateUserRelations(
	data: UserRelations,
	flowType: string,
	mifidStatus: number,
	isEmployeeWeb: boolean
): UserRelations {
	const children = DecorateItem(data.children || [], flowType, mifidStatus, isEmployeeWeb);
	const companies = DecorateItem(data.companies, flowType, mifidStatus, isEmployeeWeb);
	const person = DecorateItem([data.person], flowType, mifidStatus, isEmployeeWeb)[0];
	return { children, companies, person };
}

function DecorateItem(items: EntityProcessInfo[], flowType: string, mifidStatus: number, isEmployeeWeb: boolean) {
	if (flowType.startsWith(RENEW_PREFIX)) {
		return items.map(item => ({ ...item, disabledCard: false, disabledButton: false }));
	}
	if (FLOW_TYPE.ES_MV === flowType) {
		const unfinishedMifid = MIFID_STATUS.HasNotFinishedMifid === mifidStatus;
		return items.map(item => {
			const disabledCard = unfinishedMifid || item?.processInfo?.processStatus >= PROCESS_STATUS.InSigning;
			const disabledButton = PROCESS_STATUS.InSigning !== item.processInfo?.processStatus;
			return { ...item, disabledCard, disabledButton };
		});
	}
	const statuses = isEmployeeWeb ? DISABLED_STATUSES_EMPLOYEE : DISABLED_STATUSES_IPA;
	return items.map(item => {
		const disabledCard = item.processInfo?.processStatus in statuses;
		const disabledButton = PROCESS_STATUS.InSigning !== item.processInfo?.processStatus;
		return { ...item, disabledCard, disabledButton };
	});
}
